import { NOTIFICATION_STATUS } from '~~/types/components/Notification/NotificationStatus';

const successCssClasses = {
  border: 'border-EXPONDO-green',
  background: 'bg-EXPONDO-green-light',
  icon: 'iconify svg--checkmark text-xs text-EXPONDO-white bg-EXPONDO-green p-0.5 rounded-full block',
};
export const notificationCssClasses = {
  [NOTIFICATION_STATUS.info]: {
    border: 'border-EXPONDO-primary-60',
    background: 'bg-EXPONDO-primary-5',
    icon: 'iconify svg--info text-EXPONDO-primary-60',
  },
  [NOTIFICATION_STATUS.success]: successCssClasses,
  [NOTIFICATION_STATUS.secondarySuccess]: {
    ...successCssClasses,
    background: '',
  },
  [NOTIFICATION_STATUS.warning]: {
    border: 'border-EXPONDO-gold',
    background: 'bg-EXPONDO-yellow-light',
    icon: `iconify svg--warning text-xs text-EXPONDO-grey bg-EXPONDO-gold
      p-2 pl-1.5 rounded-full block w-4 h-4 text-center`,
  },
  [NOTIFICATION_STATUS.error]: {
    border: 'border-EXPONDO-red',
    background: 'bg-EXPONDO-red-light',
    icon: `iconify svg--zoom-out text-xs text-EXPONDO-white bg-EXPONDO-red
      p-0.5 rounded-full block w-4 h-4 transform-gpu rotate-45`,
  },
};
